import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutFocusDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutFocusDeleteCmd.validationSchema()
  );

  constructor(readonly cmd: RoomStageLayoutFocusDelete) {
    JsonSchemaValidator.assert(RoomStageLayoutFocusDeleteCmd.validation, cmd);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomStageLayoutFocusDelete {
  roomId: RoomId;
}
